<template>
  <div class="modal fade" id="customer_coupons" data-backdrop="static" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="myModalLabel">Coupons of Customer: {{customerName}} </h4>
        </div>
        <div class="modal-body">
          <ul class="list-unstyled">
            <li v-for="coupons in customerCoupons" v-bind:key="coupons.id">
              <address>
                <b class="text-danger" v-if="coupons.redeemed">This coupons is redeemed!</b>
                <br/>
                <strong>Coupon Code: </strong> {{ coupons.couponCode }}
                <a title="Delete Coupon"
                   v-on:click="deleteCoupon(coupons.id)">
                  <i class="fa fa-trash"/>
                </a>
                &nbsp;
                <br>
                <span>
                  Discount: {{ (coupons.inPercentage) ? coupons.discount + "%" : "FLAT-" + coupons.discount }}
                </span>
                <br/>

                <abbr>
                  Start Date:
                  <i>
                    {{coupons.startDate | formatDate}}
                  </i>
                </abbr>
                <br/>

                <abbr>
                  End Date:
                  <i>
                    {{coupons.endDate | formatDate}}
                  </i>
                </abbr>

              </address>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default"
                  data-dismiss="modal"
                  @click="resetData">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getBaykedCustomerCoupons} from "../../api/customers";
import {deleteCoupon} from "../../api/restaurants";

export default {
  name: "ViewCustomerCoupons",
  data() {
    return {
      customerCoupons: [],
      actionBtnLoadingClass: "",
      customerName: "",
      customerId: ""
    }
  },
  methods: {
    displayCustomersModal: function (value) {
      setTimeout(() => {
        $("#customer_coupons").modal(value);
        $("#customer_coupons").focus();
      }, 500);
    },
    resetData: function () {
        if(this.$route.query.customerId) {
            this.$router.replace({'query': null});
        }
      Object.assign(this.$data, this.$options.data.call(this));
      this.$parent.dtTable.draw();
    },
    getCustomerCoupons: async function (customer_id, customer_name) {
      this.customerId = customer_id;
      this.showLoading();
      let customerCouponsResp = await getBaykedCustomerCoupons(customer_id)
          .catch(ex => {
            this.showErrorMessage(ex);
          });
      if (customerCouponsResp.data.status === 200) {
        Swal.close();
        this.customerCoupons = customerCouponsResp.data.body;
        this.customerName = (this.customerCoupons.length > 0) ? this.customerCoupons[0].dvmCustomers.name : customer_name;
        this.displayCustomersModal("show");
      } else {
        this.showErrorMessage("Error While Getting Customer Coupons.");
      }
    },
    deleteCoupon: async function (coupon_id) {
      Swal({
        title: 'Are you sure?',
        text: "Are you sure you want to delete this coupon!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.value) {
          let deleteCouponResp = await deleteCoupon(coupon_id).catch(ex => {
            this.showErrorMessage(ex);
          });
          console.log("Resp; ", deleteCouponResp);
          await this.getCustomerCoupons(this.customerId, this.customerName);
        }
      });
    }
  }
}
</script>

<style scoped>
.modal { overflow-x: initial !important }
</style>